import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateHomepageModule } from '../../../../../store/actions/admin/create-event';
import { updatePageModule } from '../../../../../store/actions/admin/create-event/session';
import { TemplateClassNames } from '../../../../../types/template-layouts';
import { LanguagesAbbr, PageModule } from '../../../../../types/working-model';
import '../../../../live-event/modules/blank-section/blank-section.scss';
import HomepageControls, { InitialControlsDisplay } from '../../session/editor/moduleControls/controls';
import ModalComponent from '../../../../general-ui/modal/modal';
import CustomHTML from '../../../../general-ui/edit-html/edit-html';
import SessionControls from '../../session/session-module-controls/controls';
import { useParams } from 'react-router';
import { ParamsProps } from '../../../../live-event/live-event';
import { getHomepageDefaultLanguage } from '../../../../../utils/get-language';

interface Props {
	page_module: PageModule;
	template?: TemplateClassNames;
	isSession?: boolean;
}

const BlankSection = React.forwardRef<HTMLDivElement, Props>(({ page_module, isSession = false }, ref) => {
	const [isEditing, setIsEditing] = useState(false);

	const [
		workingBlankModule,
		setWorkingBlankModule,
	] = useState<PageModule | null>({ ...page_module });

	const dispatch = useDispatch();
	const { language } = useParams() as ParamsProps;

	function closeBlankModule() {
		setIsEditing(false);
	}
	function openBlankModule() {
		setIsEditing(true);
	}
	async function finishedEditingBlank() {
		if (workingBlankModule?.id) {
			if (isSession) {
				dispatch(updatePageModule(workingBlankModule));
			} else {
				dispatch(updateHomepageModule(workingBlankModule));
			}
		}
		closeBlankModule();
	}
	function updateWorkingBlankModule(code: string) {
		setWorkingBlankModule((module: PageModule | null) => {
			if (!module) return null;
			return {
				...module,
				content: {
					html: code
				}
			};
		});
	}

	const content = page_module?.content ?? { html: '' };
	const controlsDisplay: InitialControlsDisplay = {
		changeSectionPosition: true,
		addContent: true,
	};
	return page_module.is_on ? (
		<div className="editor-wrapper blank-section" ref={ref}>
			{isSession
				? <SessionControls
					page_module={page_module}
					openEditModal={openBlankModule}
				/>
				: <HomepageControls
					module={page_module}
					display={controlsDisplay}
					openContentModal={openBlankModule}
					addContentIconAsEditIcon
					baseLanguage={getHomepageDefaultLanguage() as LanguagesAbbr}
					language={language}
				/>
			}
			<div className="module-container" dangerouslySetInnerHTML={{ __html: content?.html }}>
			</div>
			<ModalComponent
				cancellable={false}
				closeable={false}
				open={isEditing}
				onRequestClose={closeBlankModule}
				title={"Blank Module"}
				footer={(
					<>
						<button onClick={closeBlankModule} >Cancel</button>
						<button onClick={finishedEditingBlank} className="primary">Done</button>
					</>
				)}
			>
				<div>
					<label className="subtitle">Add custom HTML Code</label>

					<CustomHTML
						defaultValue={content.html ?? ''}
						onChange={updateWorkingBlankModule}
					/>
				</div>
			</ModalComponent>
		</div>
	) : null;
});

BlankSection.displayName = 'BlankSection';

export default BlankSection;
